import React, { useEffect, useState } from 'react';
import { Copy } from 'phosphor-react';
import { Tooltip } from '@material-ui/core';
import { copyToClipboard } from '../Services/utils';

const CopyButton = ({ text, tooltipDuration = 3000 }) => {
  const [showToolTip, setShowTooltip] = useState(false);
  useEffect(() => {
    if (showToolTip) {
      // Hide tooltip after 3 seconds
      setTimeout(() => setShowTooltip(false), tooltipDuration);
    }
  }, [showToolTip]);

  return (
    <Tooltip title="Kopierat!" open={showToolTip} placement="top">
      <Copy
        size={16}
        cursor="pointer"
        onClick={() => setShowTooltip(copyToClipboard(text))}
      />
    </Tooltip>
  );
};

export default CopyButton;
